import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, IconButton, Switch, Typography } from "@mui/material";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { EditOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { color } from "../../../StyleData/Config";

import WorkTypeModal from "./WorkTypeModal";

const WorkType = () => {
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const link = masterAPI["worktype"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        if (filterValue === "enableData") {
          const filterDataResult = res.data.result.filter((fil) => fil.isActive);
          console.log(filterDataResult, "worktyperesult");
          setData(filterDataResult);
          setBackUpData(res.data.result);
        } else {
          setData(res.data.result);
          setBackUpData(res.data.result);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "worktype");
        setIsLoading(false);
        setData([]);
        setBackUpData([]);
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const handleDelete = async (e, id) => {
    const enableLink = masterAPI["worktype"].enable;
    const disableLink = masterAPI["worktype"].disable;
    if (e.target.checked) {
      await axiosPrivate
        .put(`${enableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "enable ");
        });
    } else {
      await axiosPrivate
        .put(`${disableLink}/${id}`)
        .then((res) => {
          console.log(res.data);
          getData();
        })
        .catch((e) => {
          console.log(e, "disable ");
        });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{ width: color.checkBoxWidth }}>
            <Checkbox />
          </Box>
        );
      },
    },
    {
      Header: "Work Type Code",
      accessor: "code",
    },
    {
      Header: "Work Type Name",
      accessor: "workTypeName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit
                    ? color.masterEditDelButtonColor
                    : "default",
                }}
              />
            </IconButton>
            <Switch
              disabled={!actionsAllow.delete}
              checked={cell.row.original.isActive}
              onChange={(e) => {
                handleDelete(e, cell.row.original.id);
              }}
            />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);
      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["worktype"].title}
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
        buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        filterValue={filterValue}
        handleChange={handleChangeFilter}
        filterShow={true}
      />

      <Dialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <WorkTypeModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default WorkType;

